import { useTranslation } from 'next-i18next/pages';
import Link from 'next/link';

import { ReactComponent as ArrowBack } from '@pflegia/ui/icons/arrow-back.svg';
import ContainerSection from '@pflegia/ui/shared/container-section';

import PflegiaHeadline from '@domains/landing-page/components/headline/Headline';

import { JOBS } from '@shared/application/constants';

const TRANSLATION_PREFIX = 'jobsPageHub.jobsByProfession';
const PROFESSIONS = [
  { key: 'nurse', href: `${JOBS}/gesundheits-und-krankenpfleger-in` },
  { key: 'companion', href: `${JOBS}/betreuungskraft-alltagsbegleiter-in` },
  { key: 'nursingAssistant', href: `${JOBS}/gesundheits-und-krankenpflegehelfer-in` },
  { key: 'nursingSupervisor', href: `${JOBS}/pflegedienstleitung` },
];

const JobsByProfession: React.FC = () => {
  const { t } = useTranslation('jobBoard', { keyPrefix: TRANSLATION_PREFIX });

  return (
    <ContainerSection className='my-32 flex flex-col items-center hyphens-auto'>
      <PflegiaHeadline
        arrowPosition='right'
        i18nKey={`jobBoard:${TRANSLATION_PREFIX}.title`}
        showArrow
        subTitle={`jobBoard:${TRANSLATION_PREFIX}.subtitle`}
      />

      <div className='grid auto-rows-fr gap-6 md:grid-cols-2'>
        {PROFESSIONS.map(({ key, href }) => (
          <Link
            className='hover:border-primary-300 border-primary-200 flex flex-col rounded-2xl border-2 bg-white p-6 shadow-2xl transition hover:-translate-y-1'
            href={href}
            key={key}>
            <h3 className='text-default mb-2 text-xl font-medium md:text-2xl'>{t(`professions.${key}.title`)}</h3>
            <p className='text-secondary mb-6'>{t(`professions.${key}.description`)}</p>
            <p className='text-primary mt-auto flex items-center justify-between gap-4 font-medium'>
              {t(`professions.${key}.cta`)}
              <ArrowBack className='h-5 w-5 shrink-0 -scale-x-100' aria-hidden />
            </p>
          </Link>
        ))}
      </div>
    </ContainerSection>
  );
};

export default JobsByProfession;
